import script from "./TriptychResult.vue?vue&type=script&setup=true&lang=js"
export * from "./TriptychResult.vue?vue&type=script&setup=true&lang=js"

import "./TriptychResult.vue?vue&type=style&index=0&id=1608c192&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1608c192"]])

export default __exports__